import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, Switch } from 'react-router-dom';
import { Segment, Container, Menu } from 'semantic-ui-react';
import { es404 } from '../../Errors';
import {
  AlertBox,
  ConfirmBox,
  // setAlertMsg,
  // askConfirmation,
} from '../../../components/Modals';
import { MenuLinkItem } from '../../../components/Menu';
// import { logout } from '../../../helpers/auth';
// import { firebaseAuth, firebaseDb } from '../../../config/constants';
import ListRecipients from './ListRecipients';
import ListPreregistrations from './ListPreregistrations';
import AddRecipient from './AddRecipient';
import EditRecipient from './EditRecipient';
// import { base } from '../../../config/constants';

export default class Recipients extends Component {
  static propTypes = {
    habilitations: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      // selectedThemeId: null,
      // manageableThemesLoading: false,
      // manageableThemes: false,
    };
  }

  componentDidMount() {
    // this.bindOrRebindManageableThemes();
  }

  // componentWillReceiveProps(nextProps) {
  //   if (_.isEqual(nextProps.habilitations, this.props.habilitations) && this.listBinding !== null) {
  //
  //   }
  // }
  //
  // bindOrRebindManageableThemes = () => {
  //   if (!this.state.manageableThemesLoading) {
  //     this.setState({ manageableThemesLoading: true });
  //   }
  //   if (this.listBinding !== null) {
  //     base.removeBinding(this.listBinding);
  //   }
  //   this.listBinding = base.bindToState('themes', {
  //     context: this,
  //     state: 'manageableThemes',
  //     asArray: true,
  //     queries: {
  //       orderByKey: true,
  //     },
  //     then: () => this.setState({ manageableThemesLoading: false }),
  //   });
  // }

  listBinding = null;

  render() {
    return (
      <Container>
        <Segment>
          <Menu secondary pointing>
            <MenuLinkItem to="/recipients/edit" activeOnlyWhenExact={false} label="Editer un destinataire" />
            <MenuLinkItem to="/recipients/list" label="Liste des destinataires" />
            <MenuLinkItem to="/recipients/add-recipient" label="Ajouter un destinataire" />
            <MenuLinkItem to="/recipients/preregistrations" label="Préinscriptions en attente" />
          </Menu>

          <Container>
            <Switch>
              <Route
                path="/recipients/edit/:id?"
                component={props => (<EditRecipient
                  habilitations={this.props.habilitations}
                  {...props}
                />)}
              />
              <Route
                path="/recipients/list"
                component={props => (<ListRecipients
                  habilitations={this.props.habilitations}
                  {...props}
                />)}
              />
              <Route
                path="/recipients/add-recipient/"
                component={props => (<AddRecipient
                  habilitations={this.props.habilitations}
                  {...props}
                />)}
              />
              <Route
                path="/recipients/preregistrations/:id?"
                component={props => (<ListPreregistrations
                  habilitations={this.props.habilitations}
                  {...props}
                />)}
              />
              <Redirect exact from="/recipients" to="/recipients/edit" />
              <Route component={es404} />
            </Switch>
          </Container>
          <AlertBox
            propagateClosure={() => this.setState({ alert: { open: false } })}
            {...this.state.alert}
          />
          <ConfirmBox
            propagateClosure={() => this.setState({ confirm: { open: false } })}
            {...this.state.confirm}
          />
        </Segment>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/protected/Recipients/index.js